export const isEnglishInput = (input, avoidEmoji = false) => {
  const regex = new RegExp(/^[~`!@#$%^&*()_+=[\]{}|; \n'‘’:",\u00a0.\\/<>?a-zA-Z0-9-]+$/);

  const emogiRegex = new RegExp(
    /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g
  );

  return input.match(regex) || (!avoidEmoji && input.match(emogiRegex)) || !input.length;
};
